import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NO_BRAND_FOUND, NO_BRAND_MESSAGE } from "@/utils/constants/messages";
import BrandCard from "@/components/cards/BrandCard";
import { BrandListSkeleton, brandGridClass } from "@/components/skeletons";
import { Button } from "@/components/ui/button";
import { getBrandList } from "@/services/setting.service";
import { BUTTONS, HEADINGS, TEXT } from "@/utils/constants/appConstants/commonConstants";
import { isFeaturePermitted } from "@/utils/functions/rbac";
import { getListCacheBootstrap, writeListCache } from "@/utils/listPageCache";

type Props = {};

const BrandList = (_props: Props) => {
    const listBootstrap = getListCacheBootstrap("brands", {});

    const [brandList, setBrandList] = useState<any[]>(listBootstrap.items as any[]);
    const [isLoading, setIsLoading] = useState(!listBootstrap.hasCache);
    const [isUpdateBrandingPermitted, setIsUpdateBrandingPermitted] = useState(false);

    useEffect(() => {
        setIsUpdateBrandingPermitted(isFeaturePermitted("AdminPortalUpdateBrandingSetting"));
    }, []);

    useEffect(() => {
        const { cacheKey, cached } = getListCacheBootstrap("brands", {});

        if (cached) {
            setBrandList(cached.items as any[]);
            setIsLoading(false);
        } else if (brandList.length === 0) {
            setIsLoading(true);
        }

        getBrandList(
            (response: any) => {
                const nextBrands = response.brandings ?? [];
                writeListCache(cacheKey, nextBrands, nextBrands.length);
                setIsLoading(false);
                setBrandList(nextBrands);
            },
            (error: any) => {
                setIsLoading(false);
                console.log(error);
            }
        );
    }, []);

    return (
        <>
            <div className="gs-brand-list-page-header">
                <h3 className="gs-brand-list-page-title" id="brand-list">
                    {HEADINGS.BRANDS}
                </h3>
                {isUpdateBrandingPermitted && (
                    <Button asChild className="shrink-0 [&_.icon]:text-white">
                        <Link to="/brand/add" id="add-brand-btn">
                            <em className="icon ni ni-star" id="add-brand-btn-icon" />
                            <span className="uppercase tracking-wide">{BUTTONS.ADD_BRAND}</span>
                        </Link>
                    </Button>
                )}
            </div>

            <div className="gs-list-page-card gs-brand-list-card">
                <div className="gs-list-page-card-header">
                    <h4 className="gs-brand-list-section-title" id="brand-list-info">
                        {HEADINGS.BRAND_INFO}
                    </h4>
                    <p className="gs-brand-list-section-subtitle" id="all-brand-list-here">
                        {TEXT.ALL_BRAND_LIST_HERE}
                    </p>
                </div>

                <div className="gs-brand-list-body">
                    {isLoading ? (
                        <BrandListSkeleton />
                    ) : brandList.length > 0 ? (
                        <div className={brandGridClass}>
                            {brandList.map((brand) => (
                                <div key={brand.id}>
                                    <BrandCard brand={brand} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="gs-brand-list-empty">
                            <h4 className="gs-brand-list-empty-title" id="no-brand-found-msg">
                                {NO_BRAND_FOUND}
                            </h4>
                            <p className="gs-brand-list-empty-subtitle" id="no-brand-found-sub-msg">
                                {NO_BRAND_MESSAGE}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default BrandList;
